import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { Toasts } from "../toasts";
import { EstadodeCuenta } from "./modalEstadodeCuenta";
import { formatMoneda } from "../../util/varios";

const TablaEstadoCuentaMinas = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accclaseproducc = JSON.parse(localStorage.getItem("accclaseproducc"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          NOMBRE / RAZÓN SOCIAL
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "codigoclase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          RIF
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [agente, setAgente] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [facturasC, setFacturasC] = useState();
  const [verificacion, setVerificacion] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtBuscador = useRef();
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idtipoagente";
    let nomid2 = "mina";
    let orden = "idagente";

    let endpoint = `${
      op.conexion
    }/api/consulta/idsstring2rows?&campos=${campos}&id=${5}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${true}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscador.current.focus();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/agente/veragente/${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setAgente(response.data);
            SelectVerificacion(response.data);
          } else {
            SelectVerificacion(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectVerificacion = (data) => {
    let tipo = 1;

    let endpoint = `${op.conexion}/api/comun/consultaverificaciones?idcontribuyente=${data.idagente}&idtipoingreso=${tipo}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setVerificacion(response.data);
            seleccionarFacturasContribuyente(data);
          } else {
            setVerificacion([]);
            seleccionarFacturasContribuyente(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectDeudaAgenProd = (data) => {
    let endpoint = `${op.conexion}/api/minas/deudas?idagente=${
      data.idagente
    }&fecha=${fechaSistema}&tabconf=${"configminas"}&condic=${"tipodeuda=1"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setDeuda(deu);
          setHistorico(his);
        }
        setMostrar2(true);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarFacturasContribuyente = (data) => {
    let tabla = "mina";
    let endpoint = `${op.conexion}/api/comun/facturasxcontribuyente?id=${data.idagente}&nomtab=${tabla}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            SelectDeudaAgenProd(data);
            setFacturasC(response.data);
          } else {
            setFacturasC([]);
            SelectDeudaAgenProd(data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const gestionarEstadoCuenta = (op, id) => (e) => {
    if (op === 4) {
      setOperacion(4);
      SeleccionarRegistro(id);
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
  }, []);

  return (
    <div className="p-0">
      <div className="container col-md-12 py-4">
        <div className="row col-md-10 m-0 mx-auto py-4">
          <div className="col-md-12">
            <div className="row col-md-12 py-2 d-flex justify-content-between">
              <input
                type="text"
                className=" col-2 form-control form-control-sm rounded-pill"
                ref={txtBuscador}
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
          </div>
          <div className="col-md-12" style={{ margin: "auto" }}>
            <TblContainer>
              <TblHead />

              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        {item.idagente}
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", width: "250px" }}
                      >
                        {item.nombre}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        {item.rif}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        <button
                          onClick={gestionarEstadoCuenta(4, item.idagente)}
                          className={
                            accclaseproducc.substring(0, 1) === "0"
                              ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                              : "btn btn-sm  btn-info rounded-pill ml-2"
                          }
                        >
                          <i className="fas fa-eye"> Consultar</i>
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>

          <EstadodeCuenta
            show={mostrar2}
            operacion={operacion}
            agente={agente}
            tabdeuda={deuda}
            verific={verificacion}
            factura={facturasC}
            tabpago={historico}
            onHideCancela={handleCancela2}
          />

          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
        </div>
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaEstadoCuentaMinas;



// WEBPACK FOOTER //
// ./src/components/minas/tablaEstadoCuenta.js